module.exports = __webpack_public_path__ + "static/media/ten.ea581b05.svg";